import type { WriteOp } from "../components/WriteOpsHint";

export const SA_WRITE_OPS: WriteOp[] = [
  {
    channel: "CLI",
    label: "Service-Account anlegen",
    snippet:
      "kontextwerk-cli admin service-accounts create \\\n  --id ci-bot --pinned-realm team:alpha --scopes kw:ingest,kw:read",
  },
  {
    channel: "CLI",
    label: "Service-Account-Secret rotieren",
    snippet: "kontextwerk-cli admin service-accounts rotate <sa_id>",
  },
  {
    channel: "CLI",
    label: "Service-Account widerrufen",
    snippet: "kontextwerk-cli admin service-accounts revoke <sa_id>",
  },
  {
    channel: "CLI",
    label: "Bearer-Token validieren (Debug)",
    snippet: "kontextwerk-cli admin service-accounts validate-token <token>",
  },
  {
    channel: "HTTP",
    label: "Service-Account anlegen (HTTP)",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/service-accounts \\\n  -d \'{"id":"ci-bot","pinned_realm":"team:alpha","scopes":["kw:ingest"]}\'',
  },
];
